<template>
  <v-textarea
    :error="error"
    :error-messages="error ? errorMessages : null"
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="$store.getters.isDisabled"
  ></v-textarea>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
      default: null,
    },
    errorMessages: {
      type: [Array, String],
      default: null,
    },
  },
};
</script>

<style>
</style>
